import { array, boolean, nullable, number, string, type } from "superstruct";

import { ApproverSchema } from "./ApproverSchema";

export const WishlistSchema = type({
    id: number(),
    title: string(),
    isDefault: boolean(),
    isPrivate: boolean(),
    customerId: number(),
    approvers: nullable(array(ApproverSchema)),
    sentNotificationsCount: nullable(number()),
    isApproved: nullable(boolean()),
    isApprover: nullable(boolean()),
    isOwner: nullable(boolean()),
});

export const WishlistSchemaWithItems = type;
